var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a689ec1c-1ca8-4c35-bab0-6d3764876ab2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81,6.75V56.25c0,3.73-3.02,6.75-6.75,6.75H6.75c-3.73,0-6.75-3.02-6.75-6.75V6.75C0,3.02,3.02,0,6.75,0H74.25c3.73,0,6.75,3.02,6.75,6.75ZM40.5,44.1c0-4.47-4.23-8.1-9.45-8.1h-.7c-1.72,.72-3.61,1.12-5.6,1.12s-3.87-.41-5.6-1.12h-.7c-5.22,0-9.45,3.63-9.45,8.1v2.7c0,1.49,1.41,2.7,3.15,2.7h25.2c1.74,0,3.15-1.21,3.15-2.7v-2.7ZM15.75,22.5c0,4.96,4.04,9,9,9s9-4.04,9-9-4.04-9-9-9-9,4.04-9,9Zm56.25-3.38c0-.62-.51-1.12-1.12-1.12h-20.25c-.62,0-1.12,.51-1.12,1.12v2.25c0,.62,.51,1.12,1.12,1.12h20.25c.62,0,1.12-.51,1.12-1.12v-2.25Zm0,9c0-.62-.51-1.12-1.12-1.12h-20.25c-.62,0-1.12,.51-1.12,1.12v2.25c0,.62,.51,1.12,1.12,1.12h20.25c.62,0,1.12-.51,1.12-1.12v-2.25Zm0,9c0-.62-.51-1.12-1.12-1.12h-20.25c-.62,0-1.12,.51-1.12,1.12v2.25c0,.62,.51,1.12,1.12,1.12h20.25c.62,0,1.12-.51,1.12-1.12v-2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkContact);
export default __webpack_public_path__ + "static/media/dark - contact.541691de9d1074787b9c97812c566d83.svg";
export { ForwardRef as ReactComponent };